import {
  UserPinnedQuotePostRequestBody,
  UserPinnedQuotesGetRequestParams,
  UserPinnedQuotePostResponse,
} from '@lio/api-types';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useInsertPinnedQuote = () => {
  const queryClient = useQueryClient();
  const client = useClient();
  const mutationFn = ({ quoteId, userId }: UserPinnedQuotePostRequestBody & UserPinnedQuotesGetRequestParams) => {
    const url = `user/${userId}/pinned-quote`;
    return client
      .post(url, {
        json: {
          quoteId,
        },
      })
      .json<UserPinnedQuotePostResponse>();
  };
  const queryKey = ['quotes'];
  const result = useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });
  return { ...result, insertPinnedQuote: result.mutate };
};
